module.exports = __webpack_public_path__ + "img/simple.ffb7dab1.png";